import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import ExtraDetailModel from "../Modals/ExtraDetailModel";
import useModal from "../hooks/useModal";

const THEMES = {
  active: {
    bg: "bg-yellow-500 hover:bg-yellow-600 text-gray-900",
    iconBg: "bg-yellow-400",
    badge: "bg-yellow-500 text-white",
  },
  completed: {
    bg: "bg-green-500 hover:bg-green-600 text-white",
    iconBg: "bg-white/20",
    badge: "bg-green-700 text-white",
  },
};

function ExtraChapter({ studentForId }) {
  const { visable, Open, Close } = useModal();
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [selectedPart, setSelectedPart] = useState(null);

  const user = JSON.parse(localStorage.getItem("postUser"));
  const lessonValue = useSelector((state) => state.lesson.value);
  const dynamicPicture = `/extapicture/${lessonValue?.picture}`;

  // name alanlarını backend'deki key'lerle (true_false, listen_find vb.) eşitledik
  const Extrabutton = [
    {
      id: 1,
      name: "true_false",
      displayName: "True & False",
      nameTr: "Doğru & Yanlış",
      icon: "✅",
      isCompleted: lessonValue?.true_false ?? false,
    },
    {
      id: 2,
      name: "listen_find",
      displayName: "Listen & Find",
      nameTr: "Dinle & Bul",
      icon: "🎧",
      isCompleted: lessonValue?.listen_find ?? false,
    },
    {
      id: 3,
      name: "answer_question",
      displayName: "Question & Answer",
      nameTr: "Soru & Cevap",
      icon: "⁉️",
      isCompleted: lessonValue?.answer_question ?? false,
    },
    {
      id: 4,
      name: "description",
      displayName: "Description",
      nameTr: "Tanımlama",
      icon: "💡",
      isCompleted: lessonValue?.description ?? false,
    },
  ];

  const handleselectTask = async (taskKey, taskDisplayName) => {
    try {
      const response = await api.get("extra_statistics", {
        params: {
          userId: studentForId,
          name: lessonValue?.name,
          class_name: lessonValue?.class_name,
        },
      });

      if (response?.data?.result) {
        const resultData = response.data.result;

        // Modal başlığı olarak tıklanan görevin adını gönderiyoruz
        setSelectedTitle(taskDisplayName);
        setSelectedPart(resultData?.class_name || "");

        // Dinamik olarak gelen objeden ilgili array'i seçiyoruz (örn: resultData["true_false"])
        const taskDetails = resultData[taskKey] || [];
        setSelectedValue(taskDetails);

        Open("ExtraDetailModel");
      }
    } catch (error) {
      console.error("extra statistik veri çekmede hata oluştu", error);
    }
  };

  return (
    <div className="px-4 container mx-auto">
      <div className="bg-transparent w-full overflow-hidden p-6 md:p-10 bg">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Resim Bölümü */}
          <div className="md:col-span-2 relative w-full aspect-video md:h-80 overflow-hidden rounded-xl shadow-inner">
            <img
              src={dynamicPicture}
              alt={lessonValue?.title}
              className="w-full h-full transition-transform duration-500"
            />
          </div>

          {/* Butonlar Bölümü */}
          <div className="md:col-span-2 flex flex-col gap-4">
            <div className="flex flex-col gap-3">
              {Extrabutton.map((item) => {
                const currentTheme = item.isCompleted
                  ? THEMES.completed
                  : THEMES.active;

                return (
                  <button
                    key={item.id}
                    onClick={() =>
                      handleselectTask(item.name, item.displayName)
                    }
                    className={`flex items-center rounded-2xl transition-all duration-300
                       shadow-md hover:shadow-lg transform hover:-translate-y-0.5 w-full overflow-hidden ${currentTheme.bg}`}
                  >
                    <div className="grid grid-cols-6 w-full items-center text-left">
                      {/* İkon Alanı */}
                      <div
                        className={`col-span-2 text-2xl h-full min-h-[70px] flex items-center justify-center transition-colors ${currentTheme.iconBg}`}
                      >
                        <div className="p-2 bg-purple-600 rounded-full">
                          {item.icon}
                        </div>
                      </div>
                      {/* Yazı Alanı */}
                      <div className="col-span-4 p-3 flex flex-col justify-center">
                        <span className="font-bold text-sm sm:text-base leading-tight">
                          {item.displayName}
                        </span>
                        <div className="w-full my-1 border-t border-black/10" />
                        <span className="text-xs sm:text-sm opacity-90">
                          {item.nameTr}
                        </span>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <ExtraDetailModel
        visable={visable.ExtraDetailModel}
        Close={() => Close("ExtraDetailModel")}
        selectValue={selectedValue}
        title={selectedTitle}
        part={selectedPart}
      />
    </div>
  );
}

export default ExtraChapter;
